import {
    ECpmCUserRoleTypeApiEnum,
    RECpmCUserRoleTypeApiEnum
} from '../../../gen/cpm-c-api-ts/src/enums/cpmc-sdk.api-enums';
import {TableTagDef} from '../../../sdk/src/components/generic-table/table-col-def';
import {StringUtils} from '../../../sdk/src/utils/string.util';

/**
 * User role utils
 */
export abstract class UserRoleUtils {
    public static readonly typeOptions = Object.keys(ECpmCUserRoleTypeApiEnum).map((key) => ({
        label: StringUtils.toHumanFormatedStr(key.replace('MULTI_SCHEMA_TENANT_ROLE', 'CUSTOMER')),
        value: RECpmCUserRoleTypeApiEnum[key]
    }));

    public static readonly typeDescriptions: Record<string, string> = {
        ['GLOBAL']: 'Set permissions in global area and in allowed customers for the user having the role',
        ['MULTI_SCHEMA_TENANT_ROLE']: 'Set permissions in allowed customers for the user having the role'
    };

    // ===============================================================
    // ===============================================================

    /**
     * Generate the table tag defs
     * @param generateColorFromString Generate color from string method
     * @returns Generated table tag defs
     */
    public static getTypeTableTagDefs(generateColorFromString: (str: string) => string): TableTagDef[] {
        return UserRoleUtils.typeOptions.map((x) => ({
            style: {background: generateColorFromString(x.label)},
            label: x.label,
            value: x.value,
            tooltip: this.typeDescriptions[x.value]
        }));
    }
}
